import React from 'react';

/**
 * Rysunek kafelka „Jaki wallbox do Twojego auta?” na stronie głównej: słońce,
 * falownik, wallbox i samochód w stylu rysunku oferty (GrafikaOferta.jsx).
 * Zastąpił wcześniejszy rysunek konturowy (2026-09-30, prośba właściciela
 * o spójny, nowocześniejszy wygląd kafelków). BEZ białych kart pod urządzeniami:
 * na jasnym tle kafelka wyglądały jak niedokończone (uwaga właściciela 2026-10-01).
 *
 * Łańcuch mówi, skąd bierze się energia: ze słońca przez falownik do wallboxa
 * i dalej do auta. Pasek baterii w rogu karty auta ładuje się w pętli, bo
 * kreator odpowiada właśnie na pytanie, ile auto realnie przyjmie z ładowarki.
 *
 * Ruch: energia płynie kablami, bateria auta się ładuje. Oba zatrzymują się przy
 * ograniczonym ruchu (index.css). Kolory na sztywno, jak w rysunku oferty.
 * Rysunek jest dekoracyjny (`aria-hidden`), sens niesie tytuł kafelka.
 */

const NIEB = '#2563eb';
const NIEB_TLO = '#dbeafe';
const GRANAT = '#1e3a8a';
const ZIELONY = '#10b981';
const SLONCE = '#f59e0b';
const KABEL_1 = 'M52 57H96';
const KABEL_2 = 'M122 62C134 62 140 72 150 70C154 69 156 64 159 61';

const Kabel = ({ d }) => (
  <g fill="none" strokeLinecap="round">
    <path d={d} stroke="#fde68a" strokeWidth="3" />
    <path className="vv-przeplyw" d={d} stroke={SLONCE} strokeWidth="3" strokeDasharray="2 5" />
  </g>
);

const GrafikaFalownikLadowarkaAuto = ({ className = '' }) => (
  <div className={className} aria-hidden="true">
    <svg viewBox="0 2 232 80" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
      <Kabel d={KABEL_1} />
      <Kabel d={KABEL_2} />

      {/* ── Falownik ── */}
      <rect x="18" y="33" width="34" height="48" rx="7" fill={NIEB_TLO} stroke={NIEB} strokeWidth="2" />
      <rect x="24" y="39" width="22" height="9" rx="2.5" fill="#ffffff" stroke={NIEB} strokeWidth="1.4" />
      <path d="M27 63c2.5 -5.6 5.5 -5.6 8 0s5.5 5.6 8 0" fill="none" stroke={NIEB}
            strokeWidth="2" strokeLinecap="round" />
      <circle cx="45" cy="73" r="1.8" fill={ZIELONY} />

      {/* Słońce nad falownikiem: źródło energii */}
      <circle cx="16" cy="18" r="7" fill="#fbbf24" />
      <path d="M16 5.5v3M16 27.5v3M3.5 18h3M25.5 18h3M7.16 9.16l2.12 2.12M22.72 24.72l2.12 2.12M7.16 26.84l2.12 -2.12M22.72 11.28l2.12 -2.12"
            stroke={SLONCE} strokeWidth="1.8" strokeLinecap="round" />

      {/* ── Wallbox ── */}
      <rect x="96" y="32" width="26" height="40" rx="7" fill={NIEB_TLO} stroke={NIEB} strokeWidth="2" />
      <circle cx="109" cy="46" r="6" fill="#ffffff" stroke={NIEB} strokeWidth="1.6" />
      <circle cx="109" cy="46" r="2" fill={ZIELONY} />
      <rect x="104" y="58" width="10" height="8" rx="2" fill="#ffffff" stroke={NIEB} strokeWidth="1.3" />

      {/* ── Samochód ── */}
      <path d="M158 70V61Q158 57 162 57H170L178 47H204L214 57H222Q227 57 227 62V70Z"
            fill={NIEB_TLO} stroke={NIEB} strokeWidth="2" strokeLinejoin="round" />
      <path d="M181 50L175.5 56H190V50Z" fill="#ffffff" stroke={NIEB} strokeWidth="1.2" strokeLinejoin="round" />
      <path d="M193 50V56H209L203 50Z" fill="#ffffff" stroke={NIEB} strokeWidth="1.2" strokeLinejoin="round" />
      <rect x="223" y="60" width="3" height="3" rx="1" fill="#fbbf24" />
      {[170, 214].map((cx) => (
        <g key={cx}>
          <circle cx={cx} cy="71" r="6.5" fill={GRANAT} stroke="#ffffff" strokeWidth="2" />
          <circle cx={cx} cy="71" r="2" fill="#cbd5e1" />
        </g>
      ))}

      {/* Bateria auta nad samochodem: ładuje się w pętli */}
      <rect x="204" y="31" width="22" height="10" rx="2.5" fill="#ffffff" stroke={NIEB} strokeWidth="1.4" />
      <rect x="226.5" y="34" width="2.2" height="4" rx="0.8" fill={NIEB} />
      <rect className="vv-ladowanie" x="206" y="33" width="18" height="6" rx="1.5" fill={ZIELONY} />
    </svg>
  </div>
);

export default GrafikaFalownikLadowarkaAuto;
